module.exports = "<app-parent-term-list></app-parent-term-list>\r\n"